const PROFILE_DRAFT_VERSION = 1;
const PROFILE_DRAFT_PREFIX = 'employee-profile-draft';

function browserStorage() {
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage || null;
    } catch (error) {
        return null;
    }
}

export function employeeProfileDraftKey(employeeId, block) {
    return `${PROFILE_DRAFT_PREFIX}:${employeeId}:${block}`;
}

export function readEmployeeProfileDraft(employeeId, block, storage) {
    const target = storage || browserStorage();
    if (!target) return null;
    try {
        const value = JSON.parse(target.getItem(
            employeeProfileDraftKey(employeeId, block)
        ));
        return value && value.version === PROFILE_DRAFT_VERSION && value.form
            ? value
            : null;
    } catch (error) {
        return null;
    }
}

export function writeEmployeeProfileDraft(employeeId, block, draft, storage) {
    const target = storage || browserStorage();
    if (!target) return false;
    try {
        target.setItem(
            employeeProfileDraftKey(employeeId, block),
            JSON.stringify(Object.assign({}, draft, {
                version: PROFILE_DRAFT_VERSION
            }))
        );
        return true;
    } catch (error) {
        return false;
    }
}

export function clearEmployeeProfileDraft(employeeId, block, storage) {
    const target = storage || browserStorage();
    if (!target) return false;
    try {
        target.removeItem(employeeProfileDraftKey(employeeId, block));
        return true;
    } catch (error) {
        return false;
    }
}
